import { render, staticRenderFns } from "./SpecialTransformerPage.vue?vue&type=template&id=663be62b"
import script from "./SpecialTransformerPage.vue?vue&type=script&lang=js"
export * from "./SpecialTransformerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports